import { isRouteErrorResponse, useRouteError } from 'react-router';

const RootRouteErrorBoundary = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    throw new Error('Unexpected route error type thrown.');
  }

  throw error;
};

export default RootRouteErrorBoundary;
